module.exports = __webpack_public_path__ + "static/media/img1.c46342ac.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/img/img1.jpeg
// module id = 717
// module chunks = 0